/**
 * Pure route identifiers and labels for the mailbox feature (Inbox / Sent Items /
 * Rejected Items).
 *
 * These live in their own module (separate from {@link mailbox.routes.ts}, which holds the route
 * table and its provider graph) so that the navbar and the feature's services can reference these
 * enums without importing the route table — mirroring the filing feature's
 * {@link filing-routes.constants.ts} split to avoid barrel-mediated circular dependencies.
 */

/**
 * The three mailbox tabs. The value is the URL segment under {@link ROUTES.MAILBOX}.
 */
export enum MAILBOX_TAB {
  INBOX = 'inbox',
  SENT = 'sent',
  REJECTED = 'rejected',
}

/**
 * Display labels for each mailbox tab (nav fly-out and page headings).
 */
export const MAILBOX_TAB_LABELS: Record<MAILBOX_TAB, string> = {
  [MAILBOX_TAB.INBOX]: 'Inbox',
  [MAILBOX_TAB.SENT]: 'Sent Items',
  [MAILBOX_TAB.REJECTED]: 'Rejected Items',
};
